export const DEFAULT_GAME_SLUG = import.meta.env.VITE_GAME_SLUG || 'nuestra-historia';
export const API_BASE_URL = (import.meta.env.VITE_API_BASE_URL || '/api').replace(/\/$/, '');
export const ADMIN_KEY = import.meta.env.VITE_ADMIN_KEY || '';
